<template>
    <div class="banner_ways_to_search">
        <h2 class="dd-m-carousel--lites__title">{{getTranslateString(title)}}</h2>

        <div class="banner_ways_to_search_slider" style="background: url(/images/banner_ways_to_search_bg.jpg) no-repeat center; background-size: cover;">
            <div class="banner_ways_to_search_slider_inner">
                <Slick ref="slick_123" :options="slickOptions" v-if="results.length">
                    <div class="slider_ways_to_search_card" v-for="(item, index) in results" :key="index" :class="{'item_deactive' : itemOpen !== index && itemOpen !== null}">
                        <div class="img_wrpr" @click="submenuOpen(index)">
                            <img v-if="item.image" :src="item.image.desktop" alt="">
                        </div>
                        <div class="bottom_card_badge_wrpr" v-show="itemOpen !== index">
                            <div class="bottom_card_badge" @click="submenuOpen(index)">{{item.name}}</div>
                        </div>

                        <transition name="slide">
                            <div class="banner_ways_to_search_submenu" v-show="itemOpen === index">
                                <ul class="banner_ways_to_search_submenu_list" v-if="item.subcategories && item.subcategories.length">
                                    <li class="banner_ways_to_search_submenu_item" v-for="(subitem, i) in item.subcategories" :key="i">
                                        <a :href="lang + '/categoria/' + item.slug + '/' + subitem.slug">{{subitem.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </Slick>
            </div>
        </div>
    </div>
</template>

<script>
    import SlickOptions from '../../providers/slick';
    import Slick from "vue-slick";
    const slickOptions = new SlickOptions();

    import CategoryService from "../../providers/api/category-service";

    const categoryService = new CategoryService();
    export default {
        name: 'banner-ways-to-search',
        components: {Slick},
        props: ['title',],
        data: () => {
            return {
                lang: '',
                results: [],
                slickOptions: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: `<a href="" class="slider_arrow_btn arrow_prev">
                                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.59873 8L9.29937 14.7006L8 16L0 8L8 0L9.29937 1.29936L2.59873 8Z" fill="white"/>
                                    </svg>
                                </a>`,
                    nextArrow: `<a href="" class="slider_arrow_btn arrow_next">
                                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.40127 8L0.700636 1.29936L2 -6.99382e-07L10 8L2 16L0.700635 14.7006L7.40127 8Z" fill="white"/>
                                    </svg>
                                </a>`,
                    dots: false,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                        breakpoint: 850,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                        breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                // variableWidth: true,
                                // centerMode: true,
                            }
                        },
                    ]
                },
                itemOpen: null,
            }
        },
        methods:{
            submenuOpen(index){
                if(this.itemOpen !== index) {
                    this.itemOpen = index;
                } else {
                    this.itemOpen = null;
                }
                this.$refs['slick_123'].goTo(index);
            }
        },
        created() {
            this.lang = language !== 'en' ? '/' + language : '';

            categoryService.doGetCategories(true)
                .then((res) => {
                	this.results = res.data.data
                	
                	console.log(this.results);
                	
                });
                
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-ways-to-search.vue